import React, { useContext } from "react";
import EvaluacionFront from "../components/EvaluacionFront";
import EvaluacionPerfil from "../components/EvaluacionPerfil";
import Header from "../components/Header";
import { Image } from "react-bootstrap";
import Context from "../Context";

const Evaluacion = () => {
  const { showLogo } = useContext(Context);
  return (
    <>
      <section id="evaluacion">
      { showLogo && <Image
          className="logoPDF"
          src="./assets/images/cmf-logo.png"
          alt="logo cmf"
        /> }
        <Header title="Evaluación" />
        <EvaluacionPerfil />
        { showLogo && <Image
          className="logoPDF"
          src="./assets/images/cmf-logo.png"
          alt="logo cmf"
        /> }
        <Header title="Evaluación" />
        <EvaluacionFront />
      </section>
    </>
  );
};

export default Evaluacion;
